export const DOMAIN_DEMO_NAME = 'gifts.dev.eboxenterprises.com';
export const DOMAIN_DEMO_NAME1 = 'ratechapp.dev.eboxenterprises.com';
export const DOMAIN_DEMO_NAME_API = 'api.dev.eboxenterprises.com';
export const DOMAIN_DEMO_API = 'https://'+DOMAIN_DEMO_NAME_API;
export const DOMAIN_DEMO_SENETPRO_API = 'https://api-dev.senetpro.com';
